import { render, staticRenderFns } from "./ParticipantItem.vue?vue&type=template&id=5d17c9b5&scoped=true"
import script from "./ParticipantItem.vue?vue&type=script&lang=js"
export * from "./ParticipantItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d17c9b5",
  null
  
)

export default component.exports